import { render, staticRenderFns } from "./weekStarRank.vue?vue&type=template&id=1489aae0&scoped=true&"
import script from "./weekStarRank.vue?vue&type=script&lang=js&"
export * from "./weekStarRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1489aae0",
  null
  
)

export default component.exports